import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { loadUserPortfolios, createUserPortfolio } from '@/services/ai-import/aiImportService';

export function useAiImportPortfolios(enabled: boolean) {
  const [portfolios, setPortfolios] = useState<Array<{ id: string; name: string; portfolio_type?: string }>>([]);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState<string | null>(null);
  const [isCreatingPortfolio, setIsCreatingPortfolio] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function loadPortfolios() {
      try {
        const normalized = await loadUserPortfolios();
        if (!cancelled) setPortfolios(normalized);
      } catch {}
    }
    if (enabled) {
      loadPortfolios();
    } else {
      setSelectedPortfolioId(null);
    }
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  const handleCreatePortfolio = async (name: string, type: string) => {
    if (isCreatingPortfolio) return;
    setIsCreatingPortfolio(true);
    try {
      const newPortfolio = await createUserPortfolio(name, type);
      setPortfolios((prev) => [newPortfolio, ...prev]);
      setSelectedPortfolioId(newPortfolio.id);
      toast.success('Portfolio created');
    } catch (err: any) {
      toast.error(err?.message || 'Failed to create portfolio');
    } finally {
      setIsCreatingPortfolio(false);
    }
  };

  return {
    portfolios,
    selectedPortfolioId,
    setSelectedPortfolioId,
    isCreatingPortfolio,
    handleCreatePortfolio,
  };
}
